import { message } from "antd";

export const showError = (error: any,messageApi: any) => {
  if ("data" in error) {
    const errorString = error.data.message;
    const parts = errorString.split(":");
    const errorMessage = parts[1]?.trim() || "Có lỗi xảy ra";
    messageApi.open({
        type: 'error',
        content: errorMessage,
      });
  } else {
    message.error("Có lỗi xảy ra");
  }
};

export function generateCodeToPid(length: number = 12): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
}

export const removeDiacriticsAndLowercase = (str: string) => {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // Xóa dấu
    .replace(/[đĐ]/g, 'd') // Thay thế đ/Đ thành d
    .toLowerCase()
    .replace(/\s+/g, '_');
};